<template>
    <v-card elevation="0" :to="mouseOver == false ? (lang === 'en' ? `/en/attorneys/view?code=${code}` : `/attorneys/view?code=${code}`) : ''" class="lawyer-card" :class="{ 'lawyer-card--hover': mouseOver }">
        <div class="lawyer-contents mb-20px mb-lg-24px">
            <div class="lawyer-content lawyer-content--view h-100">
                <v-card tile color="grey lighten-5" height="100%">
                    <v-img :aspect-ratio="444 / 564" :src="`${lawyer?.image}`" class="mx-auto mt-auto" />
                </v-card>
            </div>
            <div v-if="mouseOver" class="lawyer-content lawyer-content--active">
                <v-img :max-width="$vuetify.breakpoint.lgAndUp ? 444 : ''" :aspect-ratio="444 / 564" :src="imageActive" class="mx-auto" />
                <div class="lawyer-content--active__inner">
                    <div class="white--text">
                        <p class="txt white--text line-height-15 lawyer__detail-txt">
                            <!-- {{ lawyer?.section1?.txt }} -->
                            {{ lawyer?.about }}
                        </p>
                        <div class="lawyer__info txt line-height-1 ellip white--text">
                            <div v-if="lawyer?.phone" class="mb-4px mb-lg-8px">
                                <a :href="'tel:' + lawyer?.phone">{{ lawyer?.phone }}</a>
                            </div>
                            <div v-if="lawyer?.email">
                                <a :href="'mailto:' + lawyer?.email">{{ lawyer?.email }}</a>
                            </div>
                        </div>
                    </div>
                    <v-btn :to="lang === 'ko' ? `/attorneys/view?code=${code}` : `/en/attorneys/view?code=${code}`" small outlined color="white" width="fit-content">
                        {{ lang === "ko" ? "더보기" : "Read More" }}
                    </v-btn>
                </div>
            </div>
        </div>
        <div class="px-12px px-md-16px">
            <h4 class="tit tit--xs line-height-1 mb-4px mb-lg-10px">
                {{ lawyer?.name }}
            </h4>
            <p class="txt txt--sm grey--text font-weight-medium line-height-1">
                {{ lawyer?.rank }}
            </p>
        </div>
    </v-card>
</template>

<script>
import api from "@/api";
export default {
    props: {
        name: { type: String, default: "" },
        position: { type: String, default: "" },
        to: { type: String, default: "" },
        about: { type: String, default: "" },
        image: { type: String, default: "" },
        imageActive: { type: String, default: "/images/common/lawyer/lawyer1-active.jpg" },
        detailTxt: { type: String, default: "" },
        tel: { type: String, default: "" },
        mail: { type: String, default: "" },
        mouseOver: { type: Boolean },
        code: { type: String },
        text: { type: String },
        lang: { type: String, default: "ko" },
    },
    mounted() {
        this.init();
        if (this.isDesktop) {
            this.initPcEvent();
        }
        if (this.isMobile) {
            this.initMobileEvent();
        }
    },
    data() {
        return {
            lawyer: {},
            window: {
                width: 0,
                height: 0,
            },
        };
    },
    methods: {
        async init() {
            if (this.lang === "ko") {
                let { lawyer } = await api.v1.lawyers.get({ params: { code: this.code, local: "ko" } });
                this.lawyer = lawyer;
            } else {
                let { lawyer } = await api.v1.lawyers.get({ params: { code: this.code, local: "en" } });
                this.lawyer = lawyer;
            }
        },
        handleResize: function () {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        // PC
        initPcEvent: function () {
            var Lawyer = document.querySelectorAll(".lawyer-card--hover>.lawyer-contents");
            for (var i = 0; i < Lawyer.length; i++) {
                Lawyer[i].addEventListener("mouseenter", LawyerOver);
                Lawyer[i].addEventListener("mouseleave", LawyerOut);
            }
        },
        destroyPcEvent: function () {
            var Lawyer = document.querySelectorAll(".lawyer-card--hover>.lawyer-contents");
            for (var i = 0; i < Lawyer.length; i++) {
                Lawyer[i].removeEventListener("mouseenter", LawyerOver);
                Lawyer[i].removeEventListener("mouseleave", LawyerOut);
            }
        },
        // Mobile
        initMobileEvent: function () {
            var Lawyer = document.querySelectorAll(".lawyer-card--hover>.lawyer-contents");
            for (var i = 0; i < Lawyer.length; i++) {
                Lawyer[i].addEventListener("click", LawyerToggle);
            }
        },
        destroyMobileEvent: function () {
            var Lawyer = document.querySelectorAll(".lawyer-card--hover>.lawyer-contents");
            for (var i = 0; i < Lawyer.length; i++) {
                Lawyer[i].removeEventListener("click", LawyerToggle);
            }
        },
    },
    computed: {
        isDesktop: function () {
            return this.window.width >= 1024;
        },
        isMobile: function () {
            return this.window.width < 1024;
        },
        // code() {
        //     return this.$route.query.code;
        // },
    },
    created() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
        if (this.isDesktop) {
            this.destroyPcEvent();
        }
        if (this.isMobile) {
            this.destroyMobileEvent();
        }
    },
    watch: {
        isDesktop: function () {
            if (this.isDesktop) {
                this.initPcEvent();
            } else {
                this.destroyPcEvent();
            }
        },
        isMobile: function () {
            if (this.isMobile) {
                this.initMobileEvent();
            } else {
                this.destroyMobileEvent();
            }
        },
    },
};

function LawyerOver() {
    this.classList.add("on-hover");
}
function LawyerOut() {
    this.classList.remove("on-hover");
}
function LawyerToggle() {
    this.classList.toggle("on-hover");
}
</script>

<style lang="scss" scoped>
.lawyer-card {
    background-color: transparent;
    &--hover {
        .lawyer-content {
            &--view {
                position: absolute;
                top: 0;
                left: 0;
            }
        }
    }
    .v-ripple__container {
        display: none;
    }
    &.v-card {
        &--link:focus:before {
            opacity: 0;
        }
    }
}

.lawyer-contents {
    position: relative;
    &.on-hover {
        .lawyer-content {
            &--active {
                transform: rotateY(0);
            }
            &--view {
                transform: rotateY(180deg);
            }
        }
    }
}

.lawyer-content {
    width: 100%;
    &--active {
        position: relative;
        transition: all ease-out 0.3s;
        z-index: 1;
        transform: rotateY(-180deg);
        backface-visibility: hidden;
        opacity: 0;
        visibility: hidden;
        animation: fade 0.1s forwards;
        &__inner {
            position: absolute;
            inset: 0;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 20px;
        }
    }
    &--view {
        backface-visibility: hidden;
        transition: all ease-out 0.3s;
    }
    .v-btn {
        &:hover {
            background-color: #fff;
            color: #000 !important;
        }
    }
}

.lawyer__detail-txt {
    min-height: 195px;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // display: -webkit-box;
    // -webkit-line-clamp: 15;
    // -webkit-box-orient: vertical;
    font-size: 16px;
}

.lawyer__info {
    position: relative;
    margin-top: 12px;
    padding-top: 12px;

    &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 20px;
        height: 1px;
        background-color: #fff;
    }
}

@keyframes fade {
    0% {
        opacity: 0;
        visibility: hidden;
    }
    100% {
        opacity: 1;
        visibility: visible;
    }
}

@media (min-width: 576px) {
    .lawyer__detail-txt {
        min-height: 152px;
        font-size: 14px;
    }
}

@media (min-width: 768px) {
    .lawyer-content--active__inner {
        padding: 30px;
    }
    .lawyer__detail-txt {
        min-height: 120px;
    }
}

@media (min-width: 1024px) {
    .lawyer-content--active__inner {
        padding: 34px 24px;
    }
    .lawyer__detail-txt {
        min-height: 135px;
        font-size: 14px;
    }
    .lawyer__info {
        margin-top: 20px;
        padding-top: 20px;

        &::after {
            width: 24px;
        }
    }
}

@media (min-width: 1200px) {
    .lawyer__detail-txt {
        min-height: 189px;
    }
}

@media (min-width: 1440px) {
    .lawyer__detail-txt {
        min-height: 270px;
        font-size: 18px;
    }
}
</style>
